import { Component, Input } from '@angular/core';

import { GridConnectService } from '../../grid/grid-connect.service';
import { CommonModule } from '@angular/common';
import { QPointToolbarButtonComponent, QPointToolbarDividerComponent } from '../../toolbar';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'qpoint-export-current-grid',
    templateUrl: './export-current-grid.component.html',
    styleUrls: ['./export-current-grid.component.scss'],
    imports: [
        CommonModule,
        QPointToolbarDividerComponent,
        QPointToolbarButtonComponent,
        NgbTooltipModule
    ]
})
export class QPointExportCurrentGridComponent {
  @Input() disabled = false;

  constructor(public gridConnectService: GridConnectService) { }

  exportExcel() {
    this.gridConnectService.exportExcel();
  }

  excelExportTooltip(): string {
    return this.gridConnectService.excelExportTooltip();
  }
}
